import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@enauka/shared/infrastructure/auth/data-access';
import set from 'date-fns/set';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {
  constructor(
    private authService: AuthService,
    private router: Router
  ) { }


  getBrandName() {
    return "zeszyt.online";
  }

  isBrandPower() {
    return location.host === 'power.mini.pw.edu.pl';
  }

  goHome() {
    this.authService.isAuthenticated$().subscribe(authenticated => {
      if (authenticated) {
        this.router.navigate(['/']);
      } else {
        location.href = '/';//pominiecie mechanizmow angulara
      }
    })
  }

  getPoczatekRokuSzkolnego(): Date {
    const now = new Date();
    const poczatekRokuSzkolnego = set(new Date(), {
      year: now.getMonth() < 8 ? now.getFullYear() - 1 : now.getFullYear(),
      month: 8,
      date: 1,
      hours: 8
    });
    return poczatekRokuSzkolnego;
  }

}
